<template>
  <div class="">
    <!-- Header and Add Button -->
    <div class="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4">
      <div>
        <h2 class="text-xl font-semibold text-gray-800">List of system-wide languages</h2>
      </div>
      <button
        @click="addingNewItem"
        class="flex items-center gap-2 bg-blue-800 hover:bg-blue-900 text-white font-semibold px-3 py-2 rounded-lg shadow transition"
      >
        <span class="material-icons text-base">add</span>
        Add New Language
      </button>
    </div>
    <!-- Table -->
    <div class="overflow-x-auto rounded-xl border border-gray-200 bg-white pb-2">
      <table class="min-w-full bg-white rounded-xl">
        <thead class="border-b">
          <tr>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">#</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Language</th>
            <th class="px-4 py-3 text-xs font-semibold text-gray-500 uppercase">Acronym</th>
            <th class="px-4 py-3"></th>
          </tr>
          <tr
            v-for="(item, idx) in all"
            :key="item._id"
            class="border-b hover:bg-gray-100 transition"
            :title="`Click to view articles under ${item.name}`"
          >
            <td class="px-4 py-3">{{ idx + 1 }}</td>
            <td class="td">{{ item.language }}</td>
            <td class="td">{{ item.culture }}</td>
            <td class="px-4 py-3">
              <vs-dropdown>
                <svg class="w-6 h-6 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <circle cx="12" cy="5" r="1.5" />
                  <circle cx="12" cy="12" r="1.5" />
                  <circle cx="12" cy="19" r="1.5" />
                </svg>
                <vs-dropdown-menu>
                  <vs-dropdown-item @click="editingItem(item)"> <vs-icon icon="create" class="align-right" /> Edit </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="
                      deleteLanguagePopup = true;
                      itemToDelete = item;
                    "
                  >
                    <vs-icon icon="delete_sweep" /> Delete
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </td>
          </tr>
        </thead>
      </table>
    </div>
    <!-- Delete Confirmation Popup -->
    <vs-popup title="Delete Language" :active.sync="deleteLanguagePopup">
      <p class="mb-4 text-lg text-gray-700">Are you sure you want to delete this language?</p>
      <div class="flex justify-end gap-2">
        <vs-button color="warning" @click="deleteLangauge">Delete</vs-button>
        <vs-button color="primary" @click="deleteLanguagePopup = false">Cancel</vs-button>
      </div>
    </vs-popup>
    <!-- Add Language Popup -->
    <vs-popup :title="!isNew ? 'Edit Language' : 'Add New Language'" :active.sync="defaultalert">
      <form @submit.prevent="btnAddLanguage">
        <div class="px-2">
          <label class="block text-sm font-semibold mb-2">Name</label>
          <vs-input v-model="lang.language" placeholder="Language Name" class="w-full" required />
          <label class="block text-sm font-semibold mb-2">Acronym</label>
          <vs-input v-model="lang.culture" placeholder="Language Acronym" class="w-full" required />

          <div class="flex flex-col md:flex-row gap-2">
            <vs-button color="primary" type="filled" class="flex-1" @click="btnAddLanguage"> Save </vs-button>
          </div>
        </div>
      </form>
    </vs-popup>
  </div>
</template>

<script>
import api from "@/rest.js";
import { API } from "@/common/constants";

export default {
  name: "LanguageSettings",
  data: () => ({
    defaultalert: false,
    deleteLanguagePopup: false,
    isNew: true,
    lang: {
      language: "",
      culture: "",
    },
    itemToDelete: "",
    itemToUpdate: "",
    all: [],
  }),
  computed: {},
  methods: {
    checkCulture(culture) {
      const unsupportedCultures = ["EN", "HI", "TA", "KN", "TE", "ML", "MR", "BN", "GU", "UR", "OR"];
      return !unsupportedCultures.includes(culture);
    },

    addingNewItem() {
      this.$data.defaultalert = true;
      this.$data.isNew = true;
      this.$data.lang = { language: "", culture: "" };
    },

    editingItem(i) {
      this.$data.lang = Object.assign({}, i);
      this.$data.defaultalert = true;
      this.$data.isNew = false;
    },

    async btnAddLanguage() {
      this.$vs.loading();
      try {
        let data = this.$data.lang;
        let r;

        if (!this.$data.isNew) r = await api.put(`${API.UPDATE_LANG}/${data._id}`, data);
        else r = await api.post(API.INSERT_LANG, data);

        if (r.status === 200) {
          this.$vs.notify({
            title: "Success" + this.$data.new ? "save" : "update",
            color: "success",
            position: "top-right",
          });
          this.$data.isNew = true;
          this.$data.itemToUpdate = "";
          this.$data.defaultalert = false;
          await this.fetchAllLanguage();
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          text: "Fetch failed.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async fetchAllLanguage() {
      this.$vs.loading();
      try {
        const r = await api.get(API.GET_LANG, {});
        if (r.status === 200) this.$data.all = r.data;
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          text: "Fetch failed.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },

    async deleteLangauge() {
      this.$vs.loading();
      try {
        const r = await api.delete(`${API.DELETE_LANG}/${this.$data.itemToDelete._id}`, this.$data.itemToDelete);
        if (r.status === 200) {
          this.$vs.notify({
            text: "Deleted Successfully",
            color: "success",
            position: "top-right",
          });
          this.$data.deleteLanguagePopup = false;
          await this.fetchAllLanguage();
        }
      } catch (error) {
        console.error(error);
        this.$vs.notify({
          text: "Delete failed.",
          color: "danger",
          position: "top-right",
        });
      } finally {
        this.$vs.loading.close();
      }
    },
  },
  created() {
    this.fetchAllLanguage();
  },
};
</script>
<style scoped>
.material-icons {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  direction: ltr;
  -webkit-font-smoothing: antialiased;
}
.mb15 {
  margin-bottom: 15px;
}

.mr15 {
  margin-right: 15px;
}

.td {
  vertical-align: middle;
}
</style>
